import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { useEffect } from "react";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider } from "@/contexts/AuthContext";
import { ReturnLoopProvider } from "@/contexts/ReturnLoopContext";
import ErrorBoundary from "@/components/ErrorBoundary";
import LandingPage from "@/pages/LandingPage";
import AboutPage from "@/pages/AboutPage";
import PrivacyPage from "@/pages/PrivacyPage";
import TermsPage from "@/pages/TermsPage";
import ContactPage from "@/pages/ContactPage";
import AppPage from "@/pages/AppPage";
import NowPage from "@/pages/NowPage";
import WhyIBuiltThisPage from "@/pages/WhyIBuiltThisPage";
import SharedTaskPage from "@/pages/SharedTaskPage";
import AdminPage from "@/pages/AdminPage";
import PromoPage from "@/pages/PromoPage";
import AuthCallback from "@/components/AuthCallback";

// Register Service Worker for PWA offline support
const registerServiceWorker = () => {
  if ('serviceWorker' in navigator) {
    window.addEventListener('load', () => {
      navigator.serviceWorker.register('/service-worker.js')
        .then((registration) => {
          console.log('[PWA] Service Worker registered:', registration.scope);
        })
        .catch((error) => {
          console.log('[PWA] Service Worker registration failed:', error);
        });
    });
  }
};

// Router wrapper to handle OAuth callback before normal routing
function AppRouter() {
  const location = useLocation();
  
  // Register service worker on mount
  useEffect(() => {
    registerServiceWorker();
  }, []);
  
  // Check URL fragment for session_id - process BEFORE normal routing
  if (location.hash?.includes('session_id=')) {
    return <AuthCallback />;
  }
  
  return (
    <Routes>
      <Route path="/" element={<LandingPage />} />
      <Route path="/app" element={<AppPage />} />
      <Route path="/now" element={<NowPage />} />
      <Route path="/about" element={<AboutPage />} />
      <Route path="/why-i-built-this" element={<WhyIBuiltThisPage />} />
      <Route path="/privacy" element={<PrivacyPage />} />
      <Route path="/terms" element={<TermsPage />} />
      <Route path="/contact" element={<ContactPage />} />
      <Route path="/shared/:shareId" element={<SharedTaskPage />} />
      <Route path="/admin" element={<AdminPage />} />
      <Route path="/promo" element={<PromoPage />} />
    </Routes>
  );
}

function App() {
  return (
    <ErrorBoundary>
      <div className="min-h-screen bg-[#FDFBF7]">
        <BrowserRouter>
          <AuthProvider>
            <ReturnLoopProvider>
              <AppRouter />
            </ReturnLoopProvider>
          </AuthProvider>
        </BrowserRouter>
        <Toaster position="bottom-center" richColors />
      </div>
    </ErrorBoundary>
  );
}

export default App;
